import { RootState } from "store/store";
import { SaleStaffQueryParams, SaleStaffType } from "../type";
import { createAction, createSlice } from "@reduxjs/toolkit";

interface SaleStaffState {
	staffList: SaleStaffType[];
	staffTotal: number;
}

const initialState: SaleStaffState = {
	staffList: [],
	staffTotal: 0,
};
export const saleStaffSlice = createSlice({
	name: "saleStaff",
	initialState,
	reducers: {
		setListSaleStaff: (state, action) => {
			state.staffList = action.payload.data;
			state.staffTotal = action.payload.total;
		},
		updateASaleStaff: (state, action) => {
			console.log({ state, action });
			const fIndex = state.staffList.findIndex(
				el => el.id === action.payload.id,
			);
			if (fIndex !== -1) {
				const data = [...state.staffList];
				data[fIndex] = action.payload;
				state.staffList = data;
			}
		},
	},
});
export const getListSaleStaffAsync = createAction(
	"saleStaff/getListSaleStaffAsync",
	(payload: GetListSaleStaffAsyncPayload) => ({
		payload,
	}),
);

export const updateASaleStaffAsync = createAction(
	"saleStaff/updateASaleStaffAsync",
	(payload: UpdateSaleStaffAsyncPayload) => ({
		payload,
	}),
);
export interface UpdateSaleStaffAsyncPayload {
	data: SaleStaffType;
	callback?: () => void;
}
export interface GetListSaleStaffAsyncPayload {
	query: SaleStaffQueryParams;
	callback?: () => void;
}
export const selectSaleStaffList = (state: RootState) =>
	state.saleStaff.staffList;
export const selectSaleStaffTotal = (state: RootState) =>
	state.saleStaff.staffTotal;

export const { setListSaleStaff, updateASaleStaff } = saleStaffSlice.actions;

export const saleStaffReducer = saleStaffSlice.reducer;
